module.exports = __webpack_public_path__ + "media/src/application/media/fond_mobile-aeb16422cb66ec9e0cf1971b1688dbfd.png";